// Build-time app version read from package.json
// With resolveJsonModule enabled in tsconfig, this is safe to import.
import pkg from "../../package.json" with { type: "json" };

export const APP_VERSION: string = pkg.version;
